export enum Endpoints {
    Configurations = '/application-configurations',
    Projects = '/projects',
    ReferenceEnergyDemand = '/reference/energy-demand'
}
